module.exports = __webpack_public_path__ + "static/media/bullet-impacts.00562b6b.svg";